module.exports = __webpack_public_path__ + "img/curved-line.b04f41e3.svg";